module.exports = __webpack_public_path__ + "static/img/best_sup_actor_frame_6.b0f55db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/best_sup_actor_frame_6.jpg
// module id = 297
// module chunks = 0